import script from "./SidebarPartial.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarPartial.vue?vue&type=script&setup=true&lang=js"

import "./SidebarPartial.vue?vue&type=style&index=0&id=189815f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189815f4"]])

export default __exports__